import { XmlRuleElement } from './xmlRuleElement.class';
import { XmlEditRuleCheckTextInsert } from './xmlEditRuleCheckTextInsert.class';
import { XmlRules } from './xmlRules.class';
import { XmlSchema } from './xmlSchema.class';
import { Xml2html } from '../xml-html-converter/xml2html.class';

export class XmlRulesCreator {
  public rules: XmlRules;

  public constructor(private schema: XmlSchema, private _floatingElementNames: string[]) {
    this.rules = new XmlRules(this.getAllElementRuleNodes(Array.from(this.schema.xsdNodes.values())));
  }

  private findXsdNodeForHtmlNode(node: Node): Node {
    const tagName = Xml2html.getTagNameFromNode(node);
    return this.schema.xsdNodes.get(tagName);
  }

  private getAllElementRuleNodes(xsdNodes: Element[]) {
    return new Map(xsdNodes.map<[string, XmlRuleElement]>(xsdNode => [xsdNode.attributes.getNamedItem('name').value, this.getRuleElementForXsdNode(xsdNode)]));
  }

  private getRuleElementForXsdNode(xsdNode: Element): XmlRuleElement {
    if (xsdNode) {
      const tagName = xsdNode.attributes.getNamedItem('name').value;
      return new XmlRuleElement({
        tagName: tagName,
        floating: this.isFloating(tagName),
        empty: this.isEmpty(xsdNode)
        // xsdRawNode: xsdNode,
      });
    } else {
      return undefined;
    }
  }

  private isEmpty(xsdNode: Node): boolean {
    if (new XmlEditRuleCheckTextInsert(this.schema.xsdNodes).isTextAllowedInThisElement(xsdNode) === true) {
      return false;
    }
    return true;
  }

  private isFloating(tagName: string): boolean {
    return this._floatingElementNames.includes(tagName);
  }
}
